import React, { useEffect, useState, useRef } from 'react';
import CarMaster from '../../views/CarMaster';
import { useCarContext } from '../Context/CarContext';



const CarMasterComponent = () => {
    const { brands, FetchBrands, FetchModels, models, body, FetchBodyType, engine, FetchEngineClass } = useCarContext();

    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);
    const getData = async () => {
        try {
            await FetchBrands();
            await FetchModels();
            await FetchBodyType();
            await FetchEngineClass();
            setLoading(false); // Set loading to false once data is fetched


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });


    return (
        <div>
           {/* {loading && <div>Loading...</div>}*/}
            {!loading && brands != null && models != null && body != null && engine != null && <CarMaster carbrands={brands} carmodels={models} bodytype={body} engineclassName={engine} />}
        </div>
    );
};


export default CarMasterComponent;